import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { updatePermissions } from "../utils/permissions";

export default function Protected({ Component }) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const login = localStorage.getItem("userMedical");
    if (!login) {
      navigate("/");
    } else {
      updatePermissions();
    }
  }, [navigate, location]);

  return <Component />;
}
